import { BAILocale } from '.';
import ru_RU from 'antd/es/locale/ru_RU';

const localeValue: BAILocale = {
  lang: 'ru',
  antdLocale: ru_RU,
};

export default localeValue;
